<template>
  <div>
    <p class="total">找到{{ total }}条结果</p>
    <van-list
      v-model="loading"
      :offset="50"
      :finished="finished"
      :error="error"
      :finished-text="List.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="list-box" v-if="loading || List.length > 0">
        <PxItem
          class="list-item"
          v-for="item in List"
          :key="item.id"
          :cover="item.other.cover"
          :title="item.title"
          :price="
            item.other.minPrice
              ? [item.other.minPrice, item.other.maxPrice]
              : [item.other.maxPrice]
          "
          :saleType="item.other.saleType"
          :author="item.other.publisher"
          :number="item.enrollment"
          @click.native="toDetail(item.id, item.other.goodsId)"
        />
      </div>
      <noneList noneType="search" v-else />
    </van-list>
  </div>
</template>

<script>
import PxItem from "@/views/mobileView/components/listItem/pxItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "Kc",
  components: { PxItem, noneList },
  data() {
    return {
      Params: {
        pageNo: 0,
        pageSize: 20,
        queryParam: {
          configMap: {
            must: [
              {
                esField: "all",
                queryValue: this.$route.query.paramStr,
              },
              {
                esField: "articleType",
                queryValue: [9],
              },
            ],
          },
          otherQueryParams: {
            platformId: 1,
          },
        },
      },
      List: [],
      total: 0,
      loading: false,
      finished: false,
      error: false,
    };
  },
  methods: {
    // 触底加载
    onLoad() {
      this.Params.pageNo += 1;
      this.getSearchList();
    },
    //跳转详情
    toDetail(id, goodsId) {
      this.$router.push({
        name: "courseDetails",
        query: {
          type: 9,
          id,
          goodsId,
        },
      });
    },
    // 获取资讯列表
    async getSearchList() {
      const resp = await this.$apis.searchServe.getEsList(this.Params);
      if (resp.resultCode == 200) {
        this.finished = resp.data.list.length < 20;
        this.List.push(...resp.data.list);
        this.total = +resp.data.total;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.total {
  text-align: center;
  font-size: 13px;
  color: #999999;
  line-height: 19px;
}
.list-box {
  margin-top: 15px;
  .list-item {
    display: inline-block;
    padding-bottom: 6px;
    margin: 0 11px 12px 0;
    width: 170px;
    border-radius: 6px;
    background-color: #fff;
    overflow: hidden;
    &:nth-child(2n) {
      // margin-left: 1px;
      margin-right: 0;
    }
  }
}
</style>
